export function MwlSymbol({ size = 40, strokeWidth = 4, className = "", testId = "mwl-symbol" }) {
  return (
    <svg
      data-testid={testId}
      className={className}
      width={size * (100 / 130)}
      height={size}
      viewBox="-4 -4 108 138"
      fill="none"
      stroke="var(--accent)"
      strokeWidth={strokeWidth}
      strokeLinejoin="miter"
      strokeLinecap="square"
      aria-label="MWL"
    >
      <polyline points="4,96 4,4 50,36 96,4 96,96" />
      <polyline points="4,4 27,96 50,64 73,96 96,4" />
      <polyline points="50,4 50,124 82,124" />
    </svg>
  );
}
